<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <div v-if=" customBackGroundLogo != '' "
      class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
      id="page-login"
      :style="{ 'background-image': 'url(' + customBackGroundLogo + ')' }"
    >
      <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
        <vx-card>
          <form>
            <div slot="no-body" class="full-page-bg-color">
              <div class="vx-row no-gutter justify-center items-center">
                <div class="vx-col hidden lg:block lg:w-1/2">
                  <div v-if=" customLogo != '' ">
                    <img :src="customLogo" alt="login" class="mx-auto" />
                  </div>
                  <div v-else>
                    <img src='@/assets/images/pages/login.png' alt="login" class="mx-auto" />
                  </div>
                </div>

                <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                  <div class="p-8 login-tabs-container">
                    <div class="vx-card__title mb-4">
                      <h4 class="mb-4">Login</h4>
                      <p>Welcome back, please login to your account.</p>
                    </div>

                    <div>
                      <div>
                        <vs-input
                          v-validate="'required|email'"
                          name="email"
                          icon-no-border
                          icon="icon icon-user"
                          icon-pack="feather"
                          label-placeholder="Email"
                          v-model="email"
                          class="w-full"
                        />
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has('email')"
                        >{{ errors.first('email') }}</span>
                      </div>
                      <div>
                        <vs-input
                          v-validate="'required'"
                          type="password"
                          name="password"
                          icon-no-border
                          icon="icon icon-lock"
                          icon-pack="feather"
                          label-placeholder="Password"
                          v-model="password"
                          class="w-full mt-6"
                        />
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has('password')"
                        >{{ errors.first('password') }}</span>
                      </div>
                      <div class="flex flex-wrap justify-between my-5">
                        <router-link to="/admin/forgot-password">Forgot Password?</router-link>
                      </div>
                      <br>
                      <vs-button class="float-right" @click="handleLogin">Login</vs-button>
                    </div>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </vx-card>
      </div>
    </div>

    <div v-else
      class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
      id="page-login"
    >
      <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
        <vx-card>
          <form>
            <div slot="no-body" class="full-page-bg-color">
              <div class="vx-row no-gutter justify-center items-center">
                <div class="vx-col hidden lg:block lg:w-1/2">
                  <div v-if=" customLogo != '' ">
                    <img :src="customLogo" alt="login" class="mx-auto" />
                  </div>
                  <div v-else>
                    <img src='@/assets/images/pages/login.png' alt="login" class="mx-auto" />
                  </div>
                </div>

                <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                  <div class="p-8 login-tabs-container">
                    <div class="vx-card__title mb-4">
                      <h4 class="mb-4">Login</h4>
                      <p>Welcome back, please login to your account.</p>
                    </div>

                    <div>
                      <div>
                        <vs-input
                          v-validate="'required|email'"
                          name="email"
                          icon-no-border
                          icon="icon icon-user"
                          icon-pack="feather"
                          label-placeholder="Email"
                          v-model="email"
                          class="w-full"
                        />
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has('email')"
                        >{{ errors.first('email') }}</span>
                      </div>
                      <div>
                        <vs-input
                          v-validate="'required'"
                          type="password"
                          name="password"
                          icon-no-border
                          icon="icon icon-lock"
                          icon-pack="feather"
                          label-placeholder="Password"
                          v-model="password"
                          class="w-full mt-6"
                        />
                        <span
                          class="text-danger text-sm"
                          v-show="errors.has('password')"
                        >{{ errors.first('password') }}</span>
                      </div>
                      <div class="flex flex-wrap justify-between my-5">
                        <router-link to="/admin/forgot-password">Forgot Password?</router-link>
                      </div>
                      <br>
                      <vs-button class="float-right" @click="handleLogin">Login</vs-button>
                    </div>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      password: "",
      checkbox_remember_me: false,
      loginForm: {},
      customLogo: '',
      customBackGroundLogo: ''
    };
  },
  mounted(){
    this.handleAssets()
    this.handleBackgroundAssets();
  },
  methods: {
    handleBackgroundAssets(){
      this.$store
      .dispatch("GetAssets","background_of_login")
      .then(response => {
          this.customBackGroundLogo = response.data.data.path;
          this.$vs.loading.close();
      })
      .catch(error => {
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
              title: "Failed to configure assets",
              text: error,
              color: "danger",
              position: "top-center"
          });
          return false;
      });
    },

    handleAssets(){
        this.$store
        .dispatch("GetAssets","logo_in_login")
        .then(response => {
            this.customLogo = response.data.data.path;
            this.$vs.loading.close();
        })
        .catch(error => {
            this.$vs.loading.close();
            // Error response
            this.$vs.notify({
                title: "Failed to configure assets",
                text: error,
                color: "danger",
                position: "top-center"
            });
            return false;
        });
    },
    
    /**
     * Login API call
     * @author Madhura shah
     */
    handleLogin() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()

          this.loginForm = {
            email: this.email,
            password: this.password,
            remember_me: this.checkbox_remember_me
          };
          // call store function
          this.$store
            .dispatch("Login", this.loginForm)
            .then(() => {
              this.$vs.loading.close()
              // Success response
              this.$vs.notify({
                title: "Welcome to Symposium Dashboard",
                text: "",
                color: "success",
                position: "top-center"
              });
              this.$router.push({ path: "/admin/dashboard" });
            })
            .catch(error => {
              this.$log.error('File : Login.vue | Function : handleLogin() | Error :', error);
              this.$vs.loading.close()
              // Error response
              this.$vs.notify({
                title: "Failed to login",
                text: error,
                color: "danger",
                position: "top-center"
              });
              return false;
            });
        } else {
          return false;
        }
      });
    },

  }
};
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>
